import React from 'react';
import { Chip } from '@mui/material';
import { useDraggable } from '@dnd-kit/core';

const DraggableDish = ({ dish }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    isDragging,
  } = useDraggable({
    id: `dish-${dish.id}`,
    data: {
      type: 'dish',
      dish: dish
    }
  });

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    opacity: isDragging ? 0.5 : 1,
    cursor: 'grab'
  };

  return (
    <Chip
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      key={dish.id}
      label={dish.name}
      variant="outlined"
      sx={{ 
        cursor: 'grab',
        '&:active': {
          cursor: 'grabbing'
        }
      }}
    />
  );
};

export default DraggableDish;